import api from "./client";
export async function getDashboardStats() {
    const res = await api.get("/admin/stats");
    return res.data;
}
